import React from 'react';

function DataStorage() {
  return (
    <div className="container">
      <p>Data Storage</p>
    </div>
  );
}

export default DataStorage;
